import WorkshopRoute from './WorkshopRoute';

export default {
  name: 'Workshop',
  location: '/workshop',
  component: WorkshopRoute,
};
